import { useEffect, useRef } from 'react';

// Global tracker to prevent duplicate initialization
if (!window.__shopifyButtonsInitialized) {
  window.__shopifyButtonsInitialized = {};
}

export default function ShopifyBuyButton({ productId, variant = 'default' }) {
  const containerRef = useRef(null);
  const buttonId = useRef(`shopify-btn-${Math.random().toString(36).substr(2, 9)}`);

  useEffect(() => {
    if (productId !== 'signal-full-guide') return;
    
    const currentButtonId = buttonId.current;
    
    if (window.__shopifyButtonsInitialized[currentButtonId]) return;

    const initShopify = () => {
      if (!window.ShopifyBuy || !window.ShopifyBuy.UI) {
        setTimeout(initShopify, 200);
        return;
      }

      if (!containerRef.current) return;
      if (window.__shopifyButtonsInitialized[currentButtonId]) return;

      window.__shopifyButtonsInitialized[currentButtonId] = true;

      const client = window.ShopifyBuy.buildClient({
        domain: 'spb1mv-65.myshopify.com',
        storefrontAccessToken: '0c8dc008716102dc190f0725df911f47',
      });

      const isPrimary = variant === 'primary';
      const buttonBgColor = isPrimary ? '#D4AF37' : '#1A1A1A';
      const buttonHoverColor = isPrimary ? '#C9A030' : '#333333';

      window.ShopifyBuy.UI.onReady(client).then(function (ui) {
        if (!containerRef.current) return;
        
        ui.createComponent('product', {
          id: '15412719124857',
          node: containerRef.current,
          moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
          options: {
            "product": {
              "contents": {
                "img": false,
                "title": false,
                "price": false,
                "description": false,
                "quantity": false
              },
              "styles": {
                "product": {
                  "text-align": "center",
                  "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "auto",
                    "margin-right": "auto",
                    "margin-bottom": "0"
                  }
                },
                "button": {
                  "font-family": "Inter, system-ui, sans-serif",
                  "font-size": "12px",
                  "padding-top": "16px",
                  "padding-bottom": "16px",
                  "letter-spacing": "0.15em",
                  "text-transform": "uppercase",
                  "font-weight": "600",
                  ":hover": { "background-color": buttonHoverColor },
                  "background-color": buttonBgColor,
                  ":focus": { "background-color": buttonHoverColor },
                  "border-radius": "0px",
                  "width": "100%",
                  "margin-left": "auto",
                  "margin-right": "auto"
                }
              },
              "text": {
                "button": "Start Your Transformation"
              }
            },
            "cart": {
              "styles": {
                "button": {
                  ":hover": { "background-color": "#C9A030" },
                  "background-color": "#D4AF37",
                  ":focus": { "background-color": "#C9A030" },
                  "border-radius": "0px"
                },
                "cart": { "background-color": "#0f0f0f" },
                "title": { "color": "#ffffff" },
                "header": { "background-color": "#0f0f0f" },
                "lineItems": { "background-color": "#0f0f0f" },
                "subtotalText": { "color": "#999999" },
                "subtotal": { "color": "#ffffff" },
                "footer": { "background-color": "#0f0f0f" },
                "close": { "color": "#ffffff", ":hover": { "color": "#D4AF37" } },
                "empty": { "color": "#999999" },
                "notice": { "color": "#999999" }
              },
              "text": { 
                "total": "Subtotal", 
                "button": "Checkout",
                "notice": ""
              },
              "popup": false
            },
            "toggle": {
              "styles": {
                "toggle": { "display": "none" },
                "count": { "display": "none" }
              }
            },
            "lineItem": {
              "styles": {
                "variantTitle": { "color": "#999999" },
                "title": { "color": "#ffffff" },
                "price": { "color": "#ffffff" },
                "quantity": { "color": "#ffffff" },
                "quantityInput": { 
                  "color": "#ffffff",
                  "background-color": "#1a1a1a",
                  "border-color": "#333333"
                },
                "quantityButton": {
                  "color": "#ffffff",
                  "background-color": "#1a1a1a",
                  "border-color": "#333333"
                },
                "quantityDecrement": {
                  "color": "#ffffff",
                  "background-color": "#1a1a1a",
                  "border-color": "#333333"
                },
                "quantityIncrement": {
                  "color": "#ffffff", 
                  "background-color": "#1a1a1a",
                  "border-color": "#333333"
                }
              }
            }
          },
        });
      });
    };

    initShopify();

    return () => {
      delete window.__shopifyButtonsInitialized[currentButtonId];
    };
  }, [productId, variant]);

  if (productId !== 'signal-full-guide') {
    return (
      <div className="text-[#999999] text-sm py-4">
        Product not available for purchase yet.
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className="shopify-buy-button w-full flex justify-center"
      style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
      data-testid={`shopify-buy-button-${productId}`}
    />
  );
}
